/**
 * What a failed request may be told to an operator. Lives beside useApi rather than inside it so a
 * suite that mocks the hook still reads the real wording.
 */

/** A dropped connection: the request never reached the API, so there is no server message to show. */
export const NETWORK_ERROR_MESSAGE = "Could not reach the API — check your connection";

/** Set by useApi on the TypeError fetch throws when the request never left the browser. */
export function isNetworkError(err: unknown): boolean {
  return (err as { network?: unknown } | null)?.network === true;
}

/**
 * The API's own message when it sent one, the caller's own wording when the request never got
 * there — never a gateway's HTML page, never "Failed to fetch".
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (isNetworkError(err)) return `${fallback} — could not reach the API`;
  const message = (err as { message?: unknown } | null)?.message;
  return typeof message === "string" && message.trim() ? message : fallback;
}
